import React from 'react'
import MainProductList, {
  MainProductListProps,
} from 'ui-shared/WrappedInputs/MainProductList'
import DrinkVariantsListPart from './DrinkVariantsListPart'

const DrinkList: React.FC<MainProductListProps> = (props) => (
  <MainProductList {...props}>
    <DrinkVariantsListPart />
  </MainProductList>
)

export default DrinkList
